/**
 * /crm/competition/catalog returns a flat catalogue; /crm/options returns a
 * catalogue under `competition`. Both response contracts are supported here.
 */
export function readCompetitionCatalog(payload) {
  const catalog = payload && typeof payload === 'object'
    ? (payload.competition && typeof payload.competition === 'object'
      ? payload.competition
      : payload)
    : {};

  return {
    providers: Array.isArray(catalog.providers) ? catalog.providers : [],
    labelSuggestions: Array.isArray(catalog.label_suggestions) ? catalog.label_suggestions : [],
  };
}

/** Include the selected value even if it was entered outside the catalogue. */
export function competitionOptions(providers, labelSuggestions, selectedProvider = '') {
  const seen = new Set();
  const result = [];
  function append(name, labelSuffix = '') {
    if (typeof name !== 'string') return;
    const key = name.trim();
    const dedupeKey = key.toLocaleLowerCase('pl-PL');
    if (!key || seen.has(dedupeKey)) return;
    seen.add(dedupeKey);
    result.push({ key, text: `${key}${labelSuffix}` });
  }

  append(selectedProvider);
  (Array.isArray(providers) ? providers : []).forEach((name) => append(name));
  (Array.isArray(labelSuggestions) ? labelSuggestions : [])
    .forEach((name) => append(name, ' · etykieta Pipedrive'));
  return result;
}
